import React, { Component } from 'react'
import './About.css'
import { getYoutubeLink } from "../../../fetcher";


export default class About extends Component {
    state = {
        tech:0,
        jobs:0,
        events:0,
        link:'https://www.youtube.com/embed/'
    }

    index = 2

    componentDidMount() {
        this.fetchLinkData();
        let timer = setInterval(() => {
        this.state.tech = this.state.tech + 10
        this.state.jobs = this.state.jobs + 2
        this.state.events = this.state.events + 1
        this.forceUpdate()
        if (this.state.tech == 1000) {
            this.state.tech = '1000'
            this.state.jobs = '250'
            clearInterval(timer)
            this.forceUpdate()
        }
        }, 10)
    }


      fetchLinkData = async () => {
        try {
          const linkData = await getYoutubeLink();
        
          linkData.records?.forEach((speakerContentElement, index) => {
            const ylink = linkData.records[1].fields;
            
            this.setState({link:ylink.Link})
          });

        } catch (error) {
          console.error(error);
        }
      };


   
  
    render() {
        return (
            <div className = "about-container">
                <div className='h-counters' ref={c => this.counter_dv = c}>
                    <div className='h-counter_container'>
                        <h1 className='h-counter_number'>{this.state.tech}+</h1>
                        <h4 className='h-counter_text'>Tech Leaders</h4>
                    </div>
                    <div className='h-counter_container'>
                        <h1 className='h-counter_number'>{this.state.jobs}+</h1>
                        <h4 className='h-counter_text'>Directors/VPs/CEOs/VCs</h4>
                    </div>
                    <div className='h-counter_container'>
                        <h1 className='h-counter_number'>{this.state.events}+</h1>
                        <h4 className='h-counter_text'>Meetups/Events</h4>
                    </div>
                </div>


                    <div className="home-about_us_wwa_content">                
                        <iframe className='youtube_video1' src={this.state.link} frameborder="0" allowfullscreen></iframe>

                        <div className='home-about_us_wwa_text'>
                            <div className = "who-we-are">Who We Are</div>
                            <div className="who-we-are-line">SVLC, founded in 2019, is one of the world's largest Leadership Communities with hundreds of Executives and Leaders, including distinguished executives, managers from world-class companies, top university professors, venture capitalists, professionals holding MBAs from top business schools, and Entrepreneurs in Silicon Valley. </div>
                        </div>
                    </div>
              

                {/* <div className="h-about_carousel">
                    <ul ref={c => this.carouselContent = c} className="h-about_carousel_container">
                        <li className="h-about_carousel_content">
                        <iframe className='youtube_video1' src="https://www.youtube.com/embed/vTVYy0ToYXM" frameborder="0" allowfullscreen></iframe>

                            <div className='h-wwa_text'>
                                <h2 className='h-wwa_title'>WHO WE ARE</h2>
                                <p className='h-wwa_content'>SVLC, founded in 2019, is one of the world's largest Leadership Communities with hundreds of Executives and Leaders, including distinguished executives, managers from world-class companies, top university professors, venture capitalists, professionals holding MBAs from top business schools, and Entrepreneurs in Silicon Valley. 
</p>
                            </div>
                        </li>
                        <li className="h-about_carousel_content">
                        <iframe className='youtube_video1' src="https://www.youtube.com/embed/vTVYy0ToYXM" frameborder="0" allowfullscreen></iframe>

                            <div className='h-wwa_text'>
                                <h2 className='h-wwa_title'>WHO WE ARE</h2>
                                <p className='h-wwa_content'>SVLC, founded in 2019, is one of the world's largest Leadership Communities with hundreds of Executives and Leaders, including distinguished executives, managers from world-class companies, top university professors, venture capitalists, professionals holding MBAs from top business schools, and Entrepreneurs in Silicon Valley. 
</p>
                            </div>
                        </li>
                        <li className="h-about_carousel_content">
                        <iframe className='youtube_video1' src="https://www.youtube.com/embed/vTVYy0ToYXM" frameborder="0" allowfullscreen></iframe>

                            <div className='h-wwa_text'>
                                <h2 className='h-wwa_title'>WHO WE ARE</h2>
                                <p className='h-wwa_content'>SVLC, founded in 2019, is one of the world's largest Leadership Communities with hundreds of Executives and Leaders, including distinguished executives, managers from world-class companies, top university professors, venture capitalists, professionals holding MBAs from top business schools, and Entrepreneurs in Silicon Valley. 
</p>
                            </div>
                        </li>
                        <li className="h-about_carousel_content">
                        <iframe className='youtube_video1' src="https://www.youtube.com/embed/vTVYy0ToYXM" frameborder="0" allowfullscreen></iframe>

                            <div className='h-wwa_text'>
                                <h2 className='h-wwa_title'>WHO WE ARE</h2>
                                <p className='h-wwa_content'>SVLC, founded in 2019, is one of the world's largest Leadership Communities with hundreds of Executives and Leaders, including distinguished executives, managers from world-class companies, top university professors, venture capitalists, professionals holding MBAs from top business schools, and Entrepreneurs in Silicon Valley. 
</p>
                            </div>
                        </li>
                        <li className="h-about_carousel_content">
                        <iframe className='youtube_video1' src="https://www.youtube.com/embed/vTVYy0ToYXM" frameborder="0" allowfullscreen></iframe>

                            <div className='h-wwa_text'>
                                <h2 className='h-wwa_title'>WHO WE ARE</h2>
                                <p className='h-wwa_content'>SVLC, founded in 2019, is one of the world's largest Leadership Communities with hundreds of Executives and Leaders, including distinguished executives, managers from world-class companies, top university professors, venture capitalists, professionals holding MBAs from top business schools, and Entrepreneurs in Silicon Valley. 
</p>
                            </div>
                        </li>
                    </ul>
                        
          
                    <ul className="h-about_carousel_dot_container">
                        <li ref={c => this.one = c} className="h-about_carousel_dot"></li>
                        <li ref={c => this.two = c} className="h-about_carousel_dot"></li>
                        <li ref={c => this.three = c} className="h-about_carousel_dot"></li>
                        <li ref={c => this.four = c} className="h-about_carousel_dot"></li>
                        <li ref={c => this.five = c} className="h-about_carousel_dot"></li>
                    </ul>
                    <div onClick={() => this.handleLeftClick()} className="h-button_left">
                        <img className="h-leftButton"  />
                    </div>
                    <div onClick={() => this.handleRightClick()} className="h-button_right">
                        <img className="h-rightButton" />
                    </div>
                </div> */}
            </div>
        )
  }
}
